module.exports = __webpack_public_path__ + "static/img/nhl-white1.6f03f13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/svg/nhl-white1.svg
// module id = 8dR2
// module chunks = 1